import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { LoadingGray } from "../../../../../../components";
import { useReadBudgetDetailedLevelById } from "../../../../../../hooks/react-query/use-read-budget-detailed-levels";
import { useReadBudgetDocument } from "../../../../../../hooks/react-query/use-read-budget-documents";
import {
    defaultReadBudgetData,
    TReadBudgetsResponse,
} from "../../../../../../services/budget/read-budgets";
import DocumentContent from "./documentation-content";

const DocumentationTab = ({
    dataBudgetById,
    isLoading,
}: {
    isLoading: boolean;
    dataBudgetById?: TReadBudgetsResponse;
}) => {
    const { budgetId } = useParams();

    const id = budgetId ?? "";
    const levelsParams = {
        length: 500,
        page: 1,
    };

    const { data: dataLevels, isLoading: isLoadingLevels } =
        useReadBudgetDetailedLevelById({
            budgetId: id,
            params: levelsParams,
        });

    const {
        data: dataDocuments,
        isLoading: isLoadingDocument,
        refetch,
    } = useReadBudgetDocument({
        budgetId: id,
    });
    if (isLoading || isLoadingLevels || isLoadingDocument)
        return (
            <Box
                width="100%"
                height="60vh"
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <LoadingGray />
            </Box>
        );
    const budgetData = dataBudgetById ?? defaultReadBudgetData;
    const documentsData = dataDocuments ?? [];
    const levelData = dataLevels?.data ?? [];

    return (
        <DocumentContent
            budgetData={budgetData}
            documentsData={documentsData}
            levelData={levelData}
            refetchDocuments={refetch}
        />
    );
};

export default DocumentationTab;
